import {ref} from 'vue'
import {ListResponse, LiveRequestParam, TagGroup, TagID} from '/@src/models/api'
import {fetchRoadshowList, updateRoadshowStatus} from '/@src/api/contentRepo'
import {ContentStatusValue, RawRoadshow} from "/@src/models/content";
import useApi from "/@src/composable/useApi";
import {AxiosPromise} from "axios";

export default function useRoadshowList() {
  const api = useApi()
  const roadshowResponse = ref<ListResponse<RawRoadshow>>()
  const getRoadshowList = async (param: LiveRequestParam) => {
    if(param.page){
      param.offset = param.limit*(param.page-1)
    }
    const ret = await fetchRoadshowList(api, param)
    if(ret.list&&ret.list.length>0){
      ret.list.forEach(it=>{
        if(it.tag_relations){
          for (const relation of it.tag_relations){
            if(relation.id === TagID.MATRIX && relation.group === TagGroup.FEATURED_FLOW){
              it.is_home = true
              break
            }
          }
        }
      })
    }
    roadshowResponse.value = ret
  }
  const updateStatus = (id:number,status:ContentStatusValue):AxiosPromise=>{
    return updateRoadshowStatus(api,id,status)
  }
  return {
    roadshowResponse,
    updateStatus,
    getRoadshowList
  }
}
